import Quill from 'quill';
import { attachMathfieldKeyboardListeners } from './math-field-keyboard';
import { QuestionserviceService } from '../services/questionservice.service';
const BlockEmbed: any = Quill.import('blots/embed');

// Define the custom Input Blot class
export class MathFieldBlot extends BlockEmbed {
  static blotName = 'input';
  static tagName = 'span';
  static className = 'mf-blot';
  static create(value) {
    const node = super.create();
    
    // Create an input element
    const mathField:any = document.createElement('math-field');

    mathField.style.minWidth = value.width || '150px';
    mathField.style.display = 'inline-block';
    // Set content if available
    if (value.content) {
      mathField.innerHTML = value.content;
    }
    
    // Make it contenteditable
    mathField.setAttribute('contenteditable', 'true');
    mathField.setAttribute('tabindex', '0');
    mathField.setAttribute('id', `__math_field_${new Date().getTime().toString()}`);
    mathField.setAttribute('class', '__math_field');
    // mathField.setAttribute('math-virtual-keyboard-policy', 'sandboxed');
    // Detect iframe and set appropriate policy
    const isInIframe = window !== window.top;
    if (isInIframe) {
      (mathField as any).mathVirtualKeyboardPolicy = 'sandboxed';
    } else {
      (mathField as any).mathVirtualKeyboardPolicy = 'manual';
    } 
       
    // Add event listeners to ensure model updates
    // document.onkeydown = function(c) {
    //   mathField.innerHTML = mathField.value;

    // }
    mathField.addEventListener('input', (event) => {

       // we are doing this instead of just setting mathField.innerHTML because the version of this quill 
      // takes the focus off math-field once anythhing in it changes including element properties.
      // Hence the need for managing the input event for mathfield outside quill
      QuestionserviceService.updateMathFieldValues(mathField.id);
      //mathField.innerHTML = mathField.value;
    });
    const containerHeight = value.pageHeight ?? (document.querySelector('.page-height-control') as HTMLElement).style.height;

    attachMathfieldKeyboardListeners({
      mathField: mathField,
      keyboard: (window as any).mathVirtualKeyboard,
      isOpen: () => this.keyboardOpen,
      setOpen: v => this.keyboardOpen = v,
      //updateLayout: () => this.updateMathFieldKeyboard(),
      pageContainerSelector: '.page-height-control',
      pageOriginalHeight: containerHeight
    });
    // Append the math field to our blot node
    node.classList.add(this.className);
    node.appendChild(mathField);
    // Auto focus the newly created math field
    // setTimeout(() => mathField.focus(), 0);
   
    return node;
  }

  static value(node) {
    const mathField = node.querySelector('math-field');
    return {
      content: mathField ? mathField.innerHTML : '',
      width: mathField ? mathField.style.minWidth : '150px'
    };
  }
}